import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'momentFormat' })
export class MomentFormatPipe implements PipeTransform {
    transform(value: moment.MomentInput, format: string, locale: string = null) {
        if (!value) {
            return '';
        }
        if(locale){
            return moment(value).locale(locale).format(format);
        }else{
            return moment(value).format(format);
        }
    }
}
